<template>
  <div class="container">
    <header>
      <div class="left">
        <img src="./logo.png" />
      </div>
      <div class="right">
        <p class="tit">广发基金58只指数产品每日播报</p>
        <p class="time">
          <span>净值更新日期：</span>
          <span>{{date1}}</span>
          <span class="s3">QDII型产品更新日期：</span>
          <span>{{date2}}</span>
        </p>
      </div>
    </header>
    <div class="l_table">
      <div class="theader">
        <p class="w1">
          <span>指数类型</span>
        </p>
        <p class="w2">
          <span>投资主题</span>
        </p>
        <p class="w3">
          <span>基金名称</span>
        </p>
        <p class="w4">
          <span>基金代码</span>
        </p>
        <p class="w5">
          <span>最新净值</span>
          <em>(元)</em>
        </p>
        <p class="w6">
          <span>日涨跌</span>
          <em>(%)</em>
        </p>
        <p class="w7">
          <span>今年以来</span>
          <em>(%)</em>
        </p>
        <p class="w8">
          <span>成立以来</span>
          <em>(%)</em>
        </p>
        <p class="w9">
          <span>场内简称</span>
        </p>
        <p class="w10">
          <span>C类免赎回费持有天数</span>
        </p>
      </div>
      <div class="model_list">
        <div v-for="(item,index) in tableData" :key="index" class="model">
          <div :style="{'height':item.height}" class="title w1">
            <span>{{item.title1}}</span>
          </div>
          <div class>
            <div v-for="(item2,index2) in item.lists" :key="index2" class="right_box">
              <div class="title2 w2">
                <span>{{item2.title2}}</span>
              </div>
              <div>
                <div v-for="(item3,index3) in item2.lists_model" :key="index3" class="info_model">
                  <div class="info_list">
                    <div
                      v-for="(itemLine,indexLine) in item3.lines"
                      :key="indexLine"
                      :class="{'minHeight':itemLine.code == 511290}"
                      class="line"
                    >
                      <p class="w3">{{itemLine.name}}</p>
                      <p class="w4">{{itemLine.code}}</p>
                      <p class="w5">{{itemLine.lastTotal}}</p>
                      <p class="w6">{{itemLine.durChange}}</p>
                      <p class="w7">{{itemLine.thisYear}}</p>
                      <p class="w8">{{itemLine.beginYear}}</p>
                    </div>
                  </div>
                  <div :style="{'height':item3.height}" class="title3 w9">
                    <!-- <div class="title3 w9"> -->
                    <span>{{item3.sortName}}</span>
                  </div>
                  <div class="num_day w10">{{item3.backDay}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottm">
      <div class="p_b">
        <p>风险提示：基金过往表</p>
        <p>现不代表未来表现</p>
        <p>，我国基金运作时间较短，不能</p>
        <p>反映证券市场发展的所有阶段。</p>
      </div>
      <div class="p_b">
        <p>详情请查阅招募说明书、</p>
        <p>基金合同等法律文件。</p>
        <p>基金有风险，投资需谨慎。</p>
      </div>
    </div>
  </div>
</template>

<script>
// http://www.gffunds.com.cn/api/v1/funds/all-nav.json
import axios from "axios";
import moment from "moment";
moment.locale("zh-cn");
export default {
  data() {
    return {
      date1: "",
      date2: "",
      tableData: [
        {
          title1: "宽基指数",
          height: "456px",
          lists: [
            {
              title2: "沪深300",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发沪深300ETF",
                      code: "510360",
                      lastTotal: "1.2489",
                      durChange: "2.25",
                      thisYear: "-7.11",
                      beginYear: "24.89"
                    },
                    {
                      name: "广发沪深300ETF联接A",
                      code: "270010",
                      lastTotal: "1.8012",
                      durChange: "2.11",
                      thisYear: "-7.07",
                      beginYear: "120.40"
                    },
                    {
                      name: "广发沪深300ETF联接C",
                      code: "002987",
                      lastTotal: "1.7826",
                      durChange: "2.11",
                      thisYear: "-7.12",
                      beginYear: "23.10"
                    }
                  ],
                  height: "71px",
                  sortName: "广发300",
                  backDay: "≥7天"
                },
                {
                  lines: [
                    {
                      name: "广发沪深300指数增强A",
                      code: "006020",
                      lastTotal: "1.2274",
                      durChange: "2.20",
                      thisYear: "-4.75",
                      beginYear: "22.74"
                    },
                    {
                      name: "广发沪深300指数增强C",
                      code: "006021",
                      lastTotal: "1.2203",
                      durChange: "2.19",
                      thisYear: "-4.84",
                      beginYear: "22.03"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "中证500",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证500ETF",
                      code: "510510",
                      lastTotal: "1.5121",
                      durChange: "3.11",
                      thisYear: "0.32",
                      beginYear: "51.21"
                    },
                    {
                      name: "广发中证500ETF联接A",
                      code: "162711",
                      lastTotal: "1.1519",
                      durChange: "2.94",
                      thisYear: "0.24",
                      beginYear: "15.19"
                    },
                    {
                      name: "广发中证500ETF联接C",
                      code: "002903",
                      lastTotal: "0.9197",
                      durChange: "2.94",
                      thisYear: "0.20",
                      beginYear: "-8.03"
                    }
                  ],
                  sortName: "广发500",
                  height: "71px",
                  backDay: "≥8天"
                }
              ]
            },
            {
              title2: "创业板",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发创业板ETF",
                      code: "159952",
                      lastTotal: "1.1370",
                      durChange: "3.26",
                      thisYear: "9.15",
                      beginYear: "13.70"
                    },
                    {
                      name: "广发创业板ETF联接A",
                      code: "003765",
                      lastTotal: "1.0815",
                      durChange: "3.08",
                      thisYear: "7.64",
                      beginYear: "8.15"
                    },
                    {
                      name: "广发创业板ETF联接C",
                      code: "003766",
                      lastTotal: "1.0816",
                      durChange: "3.08",
                      thisYear: "7.59",
                      beginYear: "8.16"
                    }
                  ],
                  sortName: "创业ETF",
                  height: "71px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "中证100",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证100ETF",
                      code: "512910",
                      lastTotal: "1.0079",
                      durChange: "1.92",
                      thisYear: "-8.68",
                      beginYear: "0.79"
                    },
                    {
                      name: "广发中证100ETF联接A",
                      code: "007135",
                      lastTotal: "0.9830",
                      durChange: "1.79",
                      thisYear: "-8.03",
                      beginYear: "-1.70"
                    },
                    {
                      name: "广发中证100ETF联接C",
                      code: "007136",
                      lastTotal: "0.9813",
                      durChange: "1.78",
                      thisYear: "-8.05",
                      beginYear: "-1.87"
                    }
                  ],
                  sortName: "100ETF",
                  height: "71px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "深证100", //深证100	广发深证100指数	162714	1.2000	2.80	-2.77	49.48	深100基
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发深证100指数",
                      code: "162714",
                      lastTotal: "1.2000",
                      durChange: "2.80",
                      thisYear: "-2.77",
                      beginYear: "49.48"
                    }
                  ],
                  sortName: "深100基",
                  height: "23px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "中小板300", //深证100	广发深证100指数	162714	1.2000	2.80	-2.77	49.48	深100基
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中小板300ETF",
                      code: "159907",
                      lastTotal: "1.3591",
                      durChange: "3.38",
                      thisYear: "2.67",
                      beginYear: "23.48"
                    },
                    {
                      name: "广发中小板300ETF联接",
                      code: "270026",
                      lastTotal: "1.1113",
                      durChange: "3.16",
                      thisYear: "2.76",
                      beginYear: "11.13"
                    }
                  ],
                  sortName: "中小300",
                  height: "47px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "中证1000", //深证100	广发深证100指数	162714	1.2000	2.80	-2.77	49.48	深100基
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证1000指数A",
                      code: "006486",
                      lastTotal: "1.2156",
                      durChange: "3.13",
                      thisYear: "3.39",
                      beginYear: "21.56"
                    },
                    {
                      name: "广发中证1000指数C",
                      code: "006487",
                      lastTotal: "1.2141",
                      durChange: "3.13",
                      thisYear: "3.28",
                      beginYear: "21.41"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            }
          ]
        },
        {
          title1: "行业指数",
          height: "600px",
          lists: [
            {
              title2: "医药卫生",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证全指医药卫生ETF",
                      code: "159938",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证全指医药卫生ETF联接A",
                      code: "001180",
                      lastTotal: "0.9566",
                      durChange: "2.82",
                      thisYear: "11.22",
                      beginYear: "-4.34"
                    },
                    {
                      name: "广发中证全指医药卫生ETF联接C",
                      code: "002978",
                      lastTotal: "0.9495",
                      durChange: "2.82",
                      thisYear: "11.17",
                      beginYear: "21.31"
                    }
                  ],
                  sortName: "医药",
                  height: "71px",
                  backDay: "≥7天"
                }
              ]
            },
            {
              title2: "信息技术",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证全指信息技术ETF",
                      code: "159939",
                      lastTotal: "1.2259",
                      durChange: "3.50",
                      thisYear: "6.17",
                      beginYear: "22.59"
                    },
                    {
                      name: "广发中证全指信息技术ETF联接A",
                      code: "000942",
                      lastTotal: "1.1444",
                      durChange: "3.29",
                      thisYear: "6.31",
                      beginYear: "14.44"
                    },
                    {
                      name: "广发中证全指信息技术ETF联接C",
                      code: "002974",
                      lastTotal: "1.1379",
                      durChange: "3.30",
                      thisYear: "6.26",
                      beginYear: "-0.74"
                    }
                  ],
                  sortName: "信息技术",
                  height: "71px",
                  backDay: "≥7天"
                }
              ]
            },
            {
              title2: "金融地产",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证全指金融地产ETF",
                      code: "159940",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    },
                    {
                      name: "广发中证全指金融地产ETF联接A",
                      code: "001469",
                      lastTotal: "1.0063",
                      durChange: "1.45",
                      thisYear: "-12.81",
                      beginYear: "0.63"
                    },
                    {
                      name: "广发中证全指金融地产ETF联接C",
                      code: "002974",
                      lastTotal: "1.1379",
                      durChange: "3.30",
                      thisYear: "6.26",
                      beginYear: "-0.74"
                    }
                  ],
                  sortName: "金融",
                  height: "71px",
                  backDay: "≥7天"
                }
              ]
            },
            {
              title2: "可选消费",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证全指可选消费ETF",
                      code: "159936",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    },
                    {
                      name: "广发中证全指可选消费ETF联接A",
                      code: "001133",
                      lastTotal: "1.0063",
                      durChange: "1.45",
                      thisYear: "-12.81",
                      beginYear: "0.63"
                    },
                    {
                      name: "广发中证全指可选消费ETF联接C",
                      code: "002977",
                      lastTotal: "1.1379",
                      durChange: "3.30",
                      thisYear: "6.26",
                      beginYear: "-0.74"
                    }
                  ],
                  sortName: "可选消费",
                  height: "71px",
                  backDay: "≥7天"
                }
              ]
            },
            {
              title2: "汽车",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证全指汽车指数A",
                      code: "004854",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    },
                    {
                      name: "广发中证全指汽车指数C",
                      code: "004855",
                      lastTotal: "1.0063",
                      durChange: "1.45",
                      thisYear: "-12.81",
                      beginYear: "0.63"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "基建工程",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证基建工程指数A",
                      code: "005223",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    },
                    {
                      name: "广发中证基建工程指数C",
                      code: "005224",
                      lastTotal: "1.0063",
                      durChange: "1.45",
                      thisYear: "-12.81",
                      beginYear: "0.63"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "建筑材料",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证全指建筑材料指数A",
                      code: "004856",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    },
                    {
                      name: "广发中证全指建筑材料指数C",
                      code: "004857",
                      lastTotal: "1.0063",
                      durChange: "1.45",
                      thisYear: "-12.81",
                      beginYear: "0.63"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "家用电器",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证全指家用电器A",
                      code: "005063",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    },
                    {
                      name: "广发中证全指家用电器C",
                      code: "005064",
                      lastTotal: "1.0063",
                      durChange: "1.45",
                      thisYear: "-12.81",
                      beginYear: "0.63"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "原材料",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证全指原材料ETF",
                      code: "159944",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    }
                  ],
                  sortName: "材料ETF",
                  height: "23px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "能源",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证全指能源ETF",
                      code: "159945",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    }
                  ],
                  sortName: "能源",
                  height: "23px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "工业",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证全指工业ETF",
                      code: "159953",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    },
                    {
                      name: "广发中证全指工业ETF联接A",
                      code: "004593",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    },
                    {
                      name: "广发中证全指工业ETF联接C",
                      code: "005692",
                      lastTotal: "0.9421",
                      durChange: "1.55",
                      thisYear: "-13.05",
                      beginYear: "-5.79"
                    }
                  ],
                  sortName: "工业ETF",
                  height: "71px",
                  backDay: "≥7天"
                }
              ]
            }
          ]
        },
        {
          title1: "主题指数",
          height: "480px",
          lists: [
            {
              title2: "芯片",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发国证半导体芯片ETF",
                      code: "159801",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "芯片基金",
                  height: "23px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "传媒",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证传媒ETF",
                      code: "512980",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证传媒ETF联接A",
                      code: "004753",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证传媒ETF联接C",
                      code: "004752",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "传媒ETF",
                  height: "71px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "军工",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证军工ETF",
                      code: "512680",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证军工ETF联接A",
                      code: "003017",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证军工ETF联接C",
                      code: "005693",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "军工基金",
                  height: "71px",
                  backDay: "≥7天"
                }
              ]
            },
            {
              title2: "医疗",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证医疗指数",
                      code: "502056",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "医疗分级",
                  height: "23px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "养老",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证养老指数A",
                      code: "000968",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证养老指数C",
                      code: "002982",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥7天"
                }
              ]
            },
            {
              title2: "环保",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证环保ETF",
                      code: "512580",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证环保ETF联接A",
                      code: "001064",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证环保ETF联接C",
                      code: "002984",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "环保ETF",
                  height: "71px",
                  backDay: "≥7天"
                }
              ]
            },
            {
              title2: "央企创新",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证环保ETF",
                      code: "515600",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证央企创新驱动ETF联接A",
                      code: "007784",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证央企创新驱动ETF联接C",
                      code: "007785",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "央企创新",
                  height: "71px",
                  backDay: "≥7天"
                }
              ]
            },
            {
              title2: "大湾区",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发粤港澳大湾区创新100ETF",
                      code: "159979",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "湾创100",
                  height: "23px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "京津冀",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证京津冀ETF",
                      code: "512780",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证京津冀ETF联接A",
                      code: "005803",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证京津冀ETF联接C",
                      code: "005804",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "京津冀基",
                  height: "71px",
                  backDay: "≥30天"
                }
              ]
            }
          ]
        },
        {
          title1: "策略指数",
          height: "48px",
          lists: [
            {
              title2: "百发100",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证百发100指数A",
                      code: "000826",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证百发100指数E",
                      code: "000827",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: ""
                }
              ]
            }
          ]
        },

        {
          title1: "海外指数",
          height: "288px",
          lists: [
            {
              title2: "纳斯达克",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发纳指100ETF",
                      code: "159941",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发纳斯达克100A",
                      code: "270042",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发纳斯达克100C",
                      code: "006479",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "纳指ETF",
                  height: "71px",
                  backDay: "≥7天"
                }
              ]
            },
            {
              title2: "美国石油企业",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发道琼斯石油指数A",
                      code: "162719",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发道琼斯石油指数C",
                      code: "004243",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "广发石油",
                  height: "47px",
                  backDay: "≥7天"
                }
              ]
            },
            {
              title2: "美国房地产",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发美国房地产指数",
                      code: "000179",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "",
                  height: "23px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "生物科技",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发生物科技指数",
                      code: "001092",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "",
                  height: "23px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "医疗保健",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发全球医疗保健",
                      code: "000369",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "",
                  height: "23px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "恒生国企",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发恒生中国企业精明指数A",
                      code: "006778",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发恒生中国企业精明指数C",
                      code: "006779",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: ""
                }
              ]
            },
            {
              title2: "恒生中型股",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发恒生中型股指数A",
                      code: "501303",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发恒生中型股指数C",
                      code: "004996",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "恒生中型",
                  height: "47px",
                  backDay: ""
                }
              ]
            }
          ]
        },
        {
          title1: "债券指数",
          height: "267px",
          lists: [
            {
              title2: "中债农发债",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中债农发债总指数A",
                      code: "007252",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中债农发债总指数C",
                      code: "007253",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "中债1-3年农发债",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中债1-3年农发债指数A",
                      code: "005623",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中债1-3年农发债指数C",
                      code: "005624",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "中债1-3年国开债",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中债1-3年国开债指数A",
                      code: "006484",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中债1-3年国开债指数C",
                      code: "006485",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "中债7-10年国开债",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中债7-10年国开债指数A",
                      code: "003376",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证7-10年国开债指数C",
                      code: "003377",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "中证10年国开债",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发中证10年期国开债指数A",
                      code: "501106",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    },
                    {
                      name: "广发中证10年期国开债指数C",
                      code: "005285",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "十年国开",
                  height: "47px",
                  backDay: "≥30天"
                }
              ]
            },
            {
              title2: "上证10年期国债",
              height: "100px",
              lists_model: [
                {
                  lines: [
                    {
                      name: "广发上证10年期国债ETF",
                      code: "511290",
                      lastTotal: "1.5502",
                      durChange: "2.97",
                      thisYear: "12.20",
                      beginYear: "55.02"
                    }
                  ],
                  sortName: "国债十年",
                  height: "26px",
                  backDay: ""
                }
              ]
            }
          ]
        }
      ]
    };
  },
  created() {},
  mounted() {
    let _this = this;
    let bool = true;
    let url = bool
      ? "http://www.gffunds.com.cn/api/v1/funds/all-nav.json"
      : "/funds/all-nav.json";
    let today = this.getWeek(new Date());
    console.log(today);
    if (today == "周六" || today == "周日" || today == "周一") {
      _this.date1 = moment(new Date())
        .weekday(-3)
        .format("YYYY-MM-DD");
      _this.date2 = moment(new Date())
        .weekday(-4)
        .format("YYYY-MM-DD");
    } else {
      console.log(78)
      _this.date1 = moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      _this.date2 = moment()
        .subtract(2, "days")
        .format("YYYY-MM-DD");
    }

    axios.get(url).then(res => {
      console.log(res);
      if (res.status == 200 && res.data.length > 0) {
        _this.tableData.map(v => {
          v.lists.map(k => {
            k.lists_model.map(m => {
              m.lines.map(w => {
                res.data.map(o => {
                  if (o.FUNDCODE == w.code) {
                    w.lastTotal = o.NAVUNIT; //最新净值
                    w.durChange = o.DAYINCREMENTRATE; //日涨跌
                    w.thisYear = o.YIELDTHISY; //今年以来
                    w.beginYear = o.YIELDCREATE; //成立至今
                  }
                });
              });
            });
          });
        });
      }
    });
  },
  methods: {
    getWeek(date) {
      // 参数时间戳
      let week = moment(date).day();
      switch (week) {
        case 1:
          return "周一";
        case 2:
          return "周二";
        case 3:
          return "周三";
        case 4:
          return "周四";
        case 5:
          return "周五";
        case 6:
          return "周六";
        case 0:
          return "周日";
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.model_list {
  .model {
    display: flex;
    align-items: center;
    background-color: #fdede4;
    color: #333;
    height: 100%;
    position: relative;
  }

  .title {
    padding: 0 10px;
    box-sizing: border-box;
    border-right: 1px solid #e2463c;
    border-bottom: 1px solid #e2463c;
    display: flex;
    align-items: center;
    justify-content: center;
    writing-mode: vertical-lr;

    span {
      writing-mode: vertical-lr;
    }
  }

  .title2 {
    box-sizing: border-box;
    // border-right:1px solid #e2463c;
  }

  .title3 {
    border-left: 1px solid #e2463c;
    border-right: 1px solid #e2463c;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .right_box {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e2463c;
  }

  .info_model {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e2463c;

    &:last-child {
      border: none;
    }

    .info_list {
      .line {
        &:first-child {
          border-top: none;
        }

        display: flex;
        align-items: center;
        border-top: 1px solid #e2463c;

        p {
          height: 23px;
          line-height: 23px;
          border-left: 1px solid #e2463c;

          &:first-child {
            // border-left:1px solid #e2463c;
          }
        }
      }

      .minHeight {
        height: 26px;

        p {
          height: 26px;
          line-height: 26px;
        }
      }
    }
  }
}

.w1 {
  width: 34px;
}

.w2 {
  width: 74px;
}

.w3 {
  width: 196px;
}

.w4 {
  width: 48px;

  span {
    width: 38px;
    line-height: 16px;
    display: inline-block;
  }
}

.w5 {
  width: 60px;
}

.w6 {
  width: 50px;
}

.w7 {
  width: 60px;
}

.w8 {
  width: 60px;
}

.w9 {
  width: 65px;
}

.w10 {
  width: 88px;
}

.l_table {
  margin-top: 10px;
  // background-color: #bc1418;
  background-image: linear-gradient(
    0deg,
    rgba(172, 5, 12, 0.33) 0%,
    rgba(244, 187, 126, 0.33) 100%
  ), linear-gradient(
    #ac050c,
    #ac050c
  );
  background-blend-mode: normal, normal;
  font-size: 13px;
  color: #fff;
  padding: 7px 4px 0;
  text-align: center;
}

.theader {
  display: flex;
  align-items: center;
  text-align: center;
  background-color: #bc1418;
  border: 1px solid #e2463c;

  p {
    padding: 7px 0;
    height: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;
    border-left: 1px solid #e2463c;
    line-height: 16px;

    &:first-child {
      border: none;
    }
  }
}

.bottm {
  background: #bc1418;
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 20px 0 40px;
  background: url('./btm.png') no-repeat;
  background-size: 100% 100%;
  .p_b{
    display:flex;
    align-items:center;
    justify-content:center;
    &:first-child{
      margin-bottom:10px;
    }
  }
  .p{
    // letter-spacing:1px;
    width:750px;
  }
}

.container {
  width: 750px;
  margin: 0 auto 50px;

  header {
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #f03732;
    padding: 80px 30px 0 50px;
    color: #fff;
    padding-top: 80px;
    box-sizing: border-box;
    background: url('./top.png') no-repeat;
    background-size: 100% 100%;

    .right {
      position: relative;

      &:after {
        content: '';
        position: absolute;
        left: -20px;
        top: 3px;
        height: 52px;
        background: #fff;
        width: 1px;
      }
    }

    .tit {
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ffffff;
      margin-bottom: 10px;
    }

    .time {
      font-size: 14px;

      .s3 {
        margin-left: 10px;
      }
    }
  }
}
*{
  font-family: "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", "WenQuanYi Micro Hei", sans-serif;
}
</style>

